import React from 'react';
import { Trash2 } from 'lucide-react';

import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { AnimationSelector } from '../../animations/components/animation-selector';
import { ToolBtn } from '../../shared/ui/tool-btn';

export const ImageSettings: React.FC = () => {
  const { canvas, selectedObject, deleteSelected } = useEditorCanvas();

  if (!canvas || !selectedObject) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <AnimationSelector layout='stacked' />
      <ToolBtn onClick={deleteSelected} variant='danger' title='Eliminar'>
        <Trash2 size={15} />
      </ToolBtn>
    </div>
  );
};
